import { AfterContentChecked, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { LoadingService } from './services/shared/loading.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit,AfterContentChecked{
  title = 'frontend';
  HTTPActivity: boolean;

  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    this.loadingService.loadingRequests.length = 0;
  }
  

  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private cdr: ChangeDetectorRef,
    public loadingService: LoadingService
  ) {
    this.cdr.detach();
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe((data) => {
        if (data.title) {
          if (window.location.pathname.includes('/persona/') && localStorage.getItem('personaTitle')) {
            this.titleService.setTitle(
              localStorage.getItem('personaTitle') + ` > ${this.translate.instant(data.title)} | APC`
            );
          } else {
            this.titleService.setTitle(`${this.translate.instant(data.title)} | APC`);
          }
        }
      });
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
